import { Company } from './Company';

export class CompanyTrustRequestor {
  public companyTrustRequestorId: number;
  public companyId: number;
  public requestorId: number;
  public company: Company;
}
